// extracted by mini-css-extract-plugin
export var actions = "_sf-4";
export var item = "_sf-1";
export var price = "_sf-3";
export var quantity = "_sf-2";
export var table = "_sf-0";